import { Box, Typography } from "@mui/material";

const PAGE_FONT = "Lato, sans-serif";

export default function ComingSoonPage({ title, message, icon }) {
  return (
    <Box
      sx={{
        minHeight: "100%",
        bgcolor: "#F9FAFB",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        py: 6,
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          bgcolor: "#F0F6FF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 2,
        }}
      >
        {icon}
      </Box>

      <Typography
        sx={{
          fontFamily: PAGE_FONT,
          fontWeight: 700,
          fontSize: 22,
          lineHeight: "32px",
          color: "#383838",
          mb: 1,
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          fontFamily: PAGE_FONT,
          fontWeight: 400,
          fontSize: 14,
          lineHeight: "22px",
          color: "#555555",
          maxWidth: 480,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}
